import { ActionTypes } from 'redux/actions/actionType';

// types
import { 
    SetHomePageAction,
} from 'types/typesRedux';

const homePageState: any = {
    homePage: [],
};

export const homePageReducer = (state= homePageState, { type, payload }: SetHomePageAction ) => {
    switch ( type ) {
        case ActionTypes.SET_HOME_PAGE_DATA:
            return {
                ...state, homePage: payload };
        default:
            return state;
    }
};
